<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 19:52:04
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceModiReason\AttendanceModiReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:21:56
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceModifiReason_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-attendance-modification-record')"
    @new="toNew"
  >
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.reason="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.attendance_modification_reason_name) }}
          </div>
        </template>
        <template v-slot:item.attendance_modification_reason_code="{ item }">
          <div class="table-title text--primary">
            {{ item.attendance_modification_reason_code }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-attendance-modification-record')"
            :editBtn="hasBtn('edit-admin-attendance-modification-record')"
            :viewBtn="hasBtn('view-admin-attendance-modification-record')"
            :title="$t('label_essweb_attendanceModifiReason_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
export default {
  name: "AttendanceModiReason",
  computed: {},
  data() {
    return {
      headers: [
        {
          text: "label_essweb_attendanceModifiReason_list_attendancModifiReasonLabel",
          value: "reason",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceModifiReason_form_codeLabel",
          value: "attendance_modification_reason_code",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      search: "",
      totalCount: 0,
      showSelect: false,
      showDelete: false,
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toNew: function () {
      this.$toPage("/admin/attendance-modification-reason/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/attendance-modification-reason/edit/"
          : "/admin/attendance-modification-reason/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_attendanceModifiReason_list_deleteAttendancModifiReasonSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/get-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
  },
};
</script>
